import React, { lazy } from 'react';
import { ShieldAlert, CheckCircle2, ChevronRight, Wrench } from 'lucide-react';
export function SideRearGlass() {
  const commonDamage = ['Driver side window shattered', 'Passenger side window broken', 'Rear window shattered', 'Car door glass broken', 'Quarter glass damage', 'Truck rear glass broken', 'Van or fleet vehicle glass damage'];
  const kosinsConfirms = ['Vehicle year, make and model', 'Which glass is broken', 'Whether power-window parts are involved', 'Glass availability', 'Insurance details', 'Appointment availability', 'Drop-off or service options'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-345">
      <div className="max-w-7xl mx-auto" data-id="element-346">
        {/* Image + intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-14" data-id="element-347">
          <div data-id="element-348">
            <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5 border border-brand-redBorder" data-id="element-349">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-350" />
              Side &amp; Rear Glass
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-351">
              <span className="text-brand-red" data-id="element-352">Side Window Shattered?</span>{' '}
              Rear Window Broken?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-353">
              Broken side or rear vehicle glass can expose your vehicle to
              weather, theft risk and safety concerns. Kosin's Glass replaces
              side windows, power window glass, car door glass, quarter glass
              and rear windows for many vehicle types.
            </p>
          </div>

          <div className="relative" data-id="element-354">
            <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200 aspect-[4/3]" data-id="element-355">
              <img src="https://cdn.magicpatterns.com/uploads/fyQT9E9St2wsFmTknUbmfv/%E2%80%9CSide_Window_Shattere.png" alt="Auto glass technician removing a shattered side window from a vehicle as part of an emergency side window replacement" className="w-full h-full object-cover" loading="lazy" data-id="element-356" />
            </div>
            <div className="hidden sm:flex absolute -bottom-5 -left-5 bg-white border border-slate-200 shadow-md rounded-xl px-4 py-3 items-center gap-3" data-id="element-357">
              <div className="bg-brand-redLight p-2 rounded-lg" data-id="element-358">
                <Wrench className="w-5 h-5 text-brand-red" data-id="element-359" />
              </div>
              <div data-id="element-360">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-361">
                  On-Site Repair
                </div>
                <div className="text-sm font-bold text-slate-900" data-id="element-362">
                  Side &amp; Rear Glass
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Two columns of bullets */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-363">
          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-364">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-365">
              <ShieldAlert className="w-6 h-6 text-brand-red" data-id="element-366" />
              Common urgent glass damage
            </h3>
            <ul className="space-y-3" data-id="element-367">
              {commonDamage.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-368">
                  <ChevronRight className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-369" />
                  <span className="text-slate-700" data-id="element-370">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-371">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-372">
              <CheckCircle2 className="w-6 h-6 text-brand-red" data-id="element-373" />
              What Kosin's will confirm
            </h3>
            <ul className="space-y-3" data-id="element-374">
              {kosinsConfirms.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-375">
                  <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-376">
                    <CheckCircle2 className="w-3 h-3 text-brand-red" strokeWidth={3} data-id="element-377" />
                  </span>
                  <span className="text-slate-700" data-id="element-378">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-379">
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-380">
            Get a Side or Rear Window Quote
          </a>
        </div>
      </div>
    </section>;
}